import config from '@/config/config'
import axios from 'axios'

export default {
    state: {
        book: [],
        groups: [],
        groupMembership: [],
        pendingActions: [],
        loadingBook: true,
        loadingGroup: true
    },
    mutations: {
        setBookOfBusiness (state, payload) {
            state.book = payload
        },
        setProducerGroups (state, payload) {
            state.groups = payload
        },
        setGroupMembership (state, payload) {
            state.groupMembership = payload
        },
        setPendingActions (state, payload) {
            state.pendingActions = payload
        },
        setLoadingBook (state, payload) {
            state.loadingBook = payload
        }
        ,
        setLoadingGroup (state, payload) {
            state.loadingGroup = payload
        }
    },
    getters: {
        groupAdminBook: state => state.book,
        groupAdminGroups: state => state.groups,
        groupAdminGroupMembership: state => state.groupMembership,
        groupAdminPendingActions: state => state.pendingActions,
        groupAdminLoadingBook: state => state.loadingBook,
        groupAdminLoadingGroup: state => state.loadingGroup
    },
    actions: {
        getGroupAdminBook ({commit}) {
            commit('setBookOfBusiness', [])
            commit('setLoadingBook', true)
            axios.get(config.apiUrl() + 'groupAdmin/getBook').then(response => {
                commit('setBookOfBusiness', response.data)
                commit('setLoadingBook', false)
            }, err => {
                commit('setBookOfBusiness', [])
                commit('setLoadingBook', false)
            })
        },
        getGroupAdminGroups ({commit}) {
            commit('setProducerGroups', [])
            commit('setLoadingGroup', true)
            axios.get(config.apiUrl() + 'groupAdmin/getGroup').then(response => {
                commit('setProducerGroups', response.data)
                commit('setLoadingGroup', false)
            }, err => {
                commit('setProducerGroups', [])
                commit('setLoadingGroup', false)
            })
        },
        getGroupMembership ({commit}, group) {
            commit('setGroupMembership', null)
            axios.get(config.apiUrl() + 'groupAdmin/getGroup/' + group + '/membership').then(response => {
                commit('setGroupMembership', response.data)
            }, err => {
                commit('setGroupMembership', [])
            })
        },
        getGroupAdminPendingActions ({commit}) {
            commit('setPendingActions', [])
            axios.get(config.apiUrl() + 'groupAdmin/pending-actions').then(response => {
                commit('setPendingActions', response.data)
            }, err => {
                commit('setPendingActions', [])
            })
        },
        // updateProducerInfo ({commit, dispatch}, data) {
        //     axios.post(config.apiUrl() + 'group_admin/update', data).then(response => {
        //         dispatch('')
        //     }, err => {
        //         commit('setGroupMembership', [])
        //     })
        // }
    }
}
